import React from 'react';
import { Toaster as Sonner } from 'sonner';
import 'sonner/dist/styles.css';

import { Icons } from '../Icons';
import { ToastIcons } from '../Toast/ToastIcons';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      theme="light"
      richColors
      closeButton
      loadingIcon={<Icons.LoadingSpinner />}
      icons={{
        warning: <ToastIcons.Warning />,
        info: <ToastIcons.Info />,
        success: <ToastIcons.Success />,
        error: <ToastIcons.Error />,
      }}
      toastOptions={{
        style: {
          width: '430px',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
